import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { voidAndCancelReturn } from '../../../store/returns/grid/returns.grid.actions';
import Global from '../../../store/global-selectors';

const VoidReturn = () => {
  const dispatch = useDispatch();

  const voidLabels = useCallback(() => {
    dispatch(voidAndCancelReturn());
  }, [dispatch]);

  const selectedReturnsCount = useSelector(Global.selectSelectedReturnsCount);
  return (
    <Button disabled={selectedReturnsCount < 1} onClick={voidLabels} theme='tertiary'>
      <FormattedMessage defaultMessage='Void Label(s)' description='returnsPageHeader.voidReturn' id='Bp8yH9' />
    </Button>
  );
};

export default VoidReturn;
